import * as React from 'react'
import styled, { css } from 'styled-components'

export interface IStyledInputProps {
  withIconLeft?: boolean
  withIconRight?: boolean
  isInvalid?: boolean
}

const Input = styled.input<IStyledInputProps>`
  padding: 10px;
  width: 100%;
  font-size: 14px;
  line-height: 150%;
  background-color: ${(props) => props.theme.color.gray[5]};
  color: ${(props) => props.theme.color.gray[90]};
  border: 1px solid ${(props) => props.theme.color.gray[30]};
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
  margin: 1px 0;

  ::placeholder,
  :-ms-input-placeholder,
  ::-ms-input-placeholder {
    color: ${(props) => props.theme.color.gray[30]};
    opacity: 1;
  }

  [disabled] {
    background-color: ${(props) => props.theme.color.gray[20]};
    border-color: ${(props) => props.theme.color.gray[30]};
    cursor: not-allowed;
  }

  :focus {
    border-color: ${(props) => props.theme.color.blue[50]};
    box-shadow: 0px 0px 0px 4px ${(props) => props.theme.color.blue[30]};
  }

  ${(props) => props.withIconLeft && withIconLeft}
  ${(props) => props.withIconRight && withIconRight}
  ${(props) => props.isInvalid && isInvalid}
`

export type InputProps = React.ComponentProps<typeof Input>

export default Input

const withIconLeft = css`
  padding-left: 38px;
`

const withIconRight = css`
  padding-right: 38px;
`

const isInvalid = css`
  &,
  &:focus {
    border-color: ${(props) => props.theme.color.red[50]};
  }
`
